import {Component, ElementRef, inject, Input, ViewChild} from '@angular/core';
import {DownloadService, UserDownloadInfo} from '@uofu-uss-aux/software-catalog-ng-core';
import {RouterLink} from '@angular/router';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgIf
  ],
})
export class DownloadComponent {

  private readonly downloadService = inject(DownloadService);

  @Input()
  download: UserDownloadInfo;

  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  downloadFile(dl: UserDownloadInfo) {
    return this.downloadService.fetchDownloadUrl(dl.id).subscribe(url => {
      this.downloadLink.nativeElement.href = url;
      this.downloadLink.nativeElement.click();
    });
  }

}
